import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 13 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M7.813 9.697H.42V7.754h7.344c.657 0 1.188-.101 1.591-.303.404-.208.7-.498.89-.869.188-.371.282-.804.282-1.299 0-.443-.094-.856-.283-1.24a2.248 2.248 0 0 0-.879-.938c-.397-.247-.914-.37-1.553-.37H4.864V15h-2.45V.781h5.4c1.093 0 2.024.192 2.792.576.769.385 1.358.915 1.768 1.592.41.67.615 1.442.615 2.315 0 .93-.208 1.728-.625 2.392-.41.658-1.002 1.162-1.777 1.514-.768.351-1.693.527-2.774.527Zm.234 1.045v1.943H.42v-1.943h7.627Z"
    }, null, -1)
  ]))]))
}
export default { render: render }